
import { Input, Button, Form, FormItem } from 'element-ui';
import FacebookButton from '@/components/FacebookButton.vue';
import GoogleView from '@/components/GoogleView.vue';
import SocialLoginBtns from '@/pages/authenticate/components/SocialLoginBtns.vue';
import CustomerService from '@/services/CustomerService';

export default {
  data() {
    return {
      login: {
        user: '',
        pass: '',
      },
      rules: {
        user: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: this.$t('Please input correct email address'),
            trigger: 'blur',
          },
        ],
      },
      isLogin: false,
      emailError: '',
      showLoginLink: false,
      customerService: null,
    };
  },
  created() {
    this.customerService = new CustomerService({
      http: this.$http,
      auth: this.$auth,
      store: this.$store,
    });
  },
  components: {
    Input,
    Button,
    Form,
    FormItem,
    FacebookButton,
    GoogleView,
    SocialLoginBtns,
  },
  methods: {
    open1() {},
    registerClick() {
      this.$refs['registerForm0'].validate((valid) => {
        if (valid) {
          this.$emit('onRegisterClick', {
            email: this.login.user,
            route: this.$route,
          });
        } else {
          return false;
        }
      });
    },
    async glogin() {
      const googleUser = await this.$gAuth.signIn();
    },
    onEmailChange() {
      if (this.isValidEmail(this.login.user)) {
        this.checkEmail();
      } else {
        this.emailError = '';
        this.showLoginLink = false;
      }
    },
    checkEmail() {
      if (this._checkTimer) clearTimeout(this._checkTimer);
      this._checkTimer = setTimeout(async () => {
        try {
          await this.customerService.checkEmailAvailability(this.login.user);
          this.emailError = '';
          this.showLoginLink = false;
        } catch (e) {
          if (e.response && e.response.status === 409) {
            this.emailError = this.$t(
              'This email is already registered. Please log in or use a different email to create a new account.'
            );
            this.showLoginLink = true;
          } else {
            console.error(e);
          }
        }
      }, 500);
    },
    isValidEmail(val) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val || '');
    },
  },
};
